<div class="flex h-full w-60 flex-col bg-white">
  <!-- ヘッダー部分 -->
  <div
    class="flex h-[var(--app-layout-header-height)] flex-col items-start justify-center border-b border-gray-200 px-4"
  >
    <a
      routerLink="/"
      class="rounded no-underline focus:ring-2 focus:ring-blue-400 focus:outline-none"
    >
      <img
        class="aspect-[263/64] h-[34px]"
        src="assets/images/app-logo.svg"
        alt="toibox application logo"
      />
    </a>
  </div>

  <!-- メインナビゲーション部分 -->

  <div class="flex-1 overflow-y-auto">
    <nav class="flex w-full flex-col pt-2">
      <app-sidenav-link
        class="h-10"
        linkTo="/"
        [exact]="true"
        icon="home"
        title="ホーム"
      />

      <ng-container>
        @for (group of sidenavGroups; track group) {
          <div class="mx-3 my-2 h-px bg-gray-200"></div>
          <div class="px-4 py-1 text-xs font-bold text-gray-500">
            {{ group.name }}
          </div>
          @for (item of group.items; track item) {
            @if (hasPermissions(item.permissions)) {
              <app-sidenav-link
                class="h-10"
                [linkTo]="item.link"
                [icon]="item.icon"
                [title]="item.title"
              />
            }
          }
        }
      </ng-container>
    </nav>
  </div>

  <!-- フッター部分 -->
  <div class="flex flex-col border-t border-gray-200 p-4">
    @if (currentUser(); as user) {
      <div class="flex w-full flex-col">
        <span
          class="mb-2 cursor-pointer text-sm font-medium text-gray-700"
          (click)="printUser(user)"
        >
          {{ user.displayName }}
        </span>
        <button
          (click)="logOut()"
          mat-stroked-button
          class="h-9 w-full text-sm"
        >
          ログアウト
        </button>
      </div>
    }
    <div class="mt-2 text-xs text-gray-500">
      <span>v{{ appVersion }}</span>
    </div>
  </div>
</div>
